(function () {
  "use strict";

  /** Paths relative to vanilla/index.html */
  var ASSETS = {
    logo: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/Link.png?v=1770008883",
    teethWhite: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/white.png?v=1777887217",
    teethYellow: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/yellow.png?v=1777887217",
    teethWorn: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/worn.png?v=1777887217",
    teethFragile: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/fragile.png?v=1777887218",
    testimonialJessica: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/testimonial-jessica.jpg?v=1777887279",
    testimonialMark: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/testimonial-mark.jpg?v=1777887278",
    stainTypes: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/tooth-discoloration-types-v3.png?v=1777887374",
    phChart: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/ph-acidity-chart.jpg?v=1777887406",
    heroImg: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/larineco-hero.png?v=1777887374",
    timelineMale: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/timeline-male.jpg?v=1777887372",
    timelineFemale: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/timeline-female.jpg?v=1777887372",
    profileMaleTeen: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-teen.jpg?v=1777887628",
    profileMale20: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-20s.jpg?v=1777887627",
    profileMale30: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-30s.jpg?v=1777887628",
    profileMale40: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-40s.jpg?v=1777887628",
    profileMale50: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-50s.jpg?v=1777887628",
    profileFemaleTeen: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-teen.jpg?v=1777887628",
    profileFemale20: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-20s.jpg?v=1777887627",
    profileFemale30: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-30s.jpg?v=1777887627",
    profileFemale40: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-40s.jpg?v=1777887626",
    profileFemale50: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-50s.jpg?v=1777887627",
  };

  var TOTAL_Q = 13;

  var TEETH_OPTS = [
    ["white", ASSETS.teethWhite, "White & healthy"],
    ["yellow", ASSETS.teethYellow, "Slightly yellow"],
    ["worn", ASSETS.teethWorn, "Sensitive & worn"],
    ["fragile", ASSETS.teethFragile, "Thinning & fragile"],
  ];

  var CONCERN_OPTS = [
    ["😬", "Sensitivity and pain"],
    ["😐", "Yellowing and staining"],
    ["🦷", "Weak or thinning enamel"],
    ["💨", "Bad breath"],
    ["😁", "Overall confidence in my smile"],
  ];

  var STAIN_OPTS = [
    ["☕", "Coffee or tea"],
    ["🍷", "Wine or dark drinks"],
    ["🚬", "Smoking / tobacco"],
    ["🎂", "Age yellowing"],
    ["🍕", "Food and snacks"],
    ["❓", "Not sure"],
  ];

  var HOPES = [
    "Less sensitivity ",
    "Whiter, brighter teeth",
    "Stronger, more protected enamel",
    "Fresher breath all day",
    "More confidence in my smile",
    "All of the above",
  ];

  var WARN = [
    "Pain when biting",
    "Sensitive teeth",
    "Gums bleeding when flossing",
    "Visible white spots on teeth",
    "Bad breath that doesn't go away",
    "None of these",
  ];

  var stage = document.getElementById("stage");

  var state = {
    screen: "intro",
    answers: {},
  };

  function scrollTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function setAns(k, v) {
    state.answers[k] = v;
  }

  function go(next) {
    state.screen = next;
    render();
    scrollTop();
  }

  function cn() {
    return Array.prototype.slice.call(arguments).filter(Boolean).join(" ");
  }

  function progressHtml(step, total, label) {
    var pct = Math.round((step / total) * 100);
    var labelStr = label != null ? String(label).replace(/\u200b/g, "").trim() : "";
    var showHalfway = !labelStr && (step === 9 || step === 10);
    var displayLabel = labelStr || (showHalfway ? "You're doing great! We're almost there." : null);

    var labelBlock = displayLabel
      ? '<div class="text-[12px] font-semibold text-primary text-center mb-2">' +
        escapeHtml(displayLabel) +
        "</div>"
      : "";

    return (
      '<div class="mb-7">' +
      labelBlock +
      '<div class="h-[3px] bg-border rounded-full overflow-hidden">' +
      '<div class="h-full bg-primary rounded-full transition-all duration-500" style="width:' +
      pct +
      '%"></div>' +
      "</div></div>"
    );
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function bigCta(html, action) {
    return (
      '<button type="button" data-action="' +
      action +
      '" class="w-full py-4 bg-gradient-primary text-primary-foreground rounded-xl text-base font-bold shadow-card hover:opacity-90 transition tracking-wide">' +
      html +
      "</button>"
    );
  }

  function renderTeethSelector(isIntro) {
    var selected = state.answers.teeth_state;
    var buttons = TEETH_OPTS.map(function (row) {
      var val = row[0],
        img = row[1],
        label = row[2];
      var sel = selected === val;
      return (
        '<button type="button" data-teeth="' +
        escapeHtml(val) +
        '" class="' +
        cn(
          "border-[1.5px] rounded-xl bg-card overflow-hidden transition-all text-left flex flex-col",
          sel ? "border-primary border-2 shadow-card" : "border-border hover:border-primary"
        ) +
        '">' +
        '<div class="relative aspect-[4/3] bg-muted overflow-hidden">' +
        '<img src="' +
        img +
        '" alt="' +
        escapeHtml(label) +
        '" loading="lazy" class="w-full h-full object-cover" />' +
        (sel
          ? '<span class="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold shadow-card">✓</span>'
          : "") +
        "</div>" +
        '<div class="' +
        cn("p-2.5 text-center transition-colors", sel && "bg-primary-soft") +
        '">' +
        '<div class="text-[13px] font-bold text-foreground leading-tight">' +
        escapeHtml(label) +
        "</div></div></button>"
      );
    }).join("");

    var progress = isIntro ? "" : progressHtml(1, TOTAL_Q);

    return (
      '<div class="' +
      (isIntro ? "" : "animate-fade-up") +
      '">' +
      progress +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">Which of these most resembles your teeth right now?</h2>' +
      '<div class="grid grid-cols-2 gap-3 mt-3">' +
      buttons +
      "</div></div>"
    );
  }

  function bindTeeth(root, isIntro) {
    root.querySelectorAll("[data-teeth]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var val = btn.getAttribute("data-teeth");
        setAns("teeth_state", val);
        setTimeout(function () {
          go("q-concern");
        }, 280);
      });
    });
  }

  function renderIntro() {
    stage.innerHTML =
      '<div class="animate-fade-up">' +
      '<h1 class="text-[26px] leading-[1.25] font-normal text-center text-foreground mb-2.5">Find Out Why <span class="font-bold text-primary">Your Teeth Are Sensitive</span></h1>' +
      '<p class="text-sm text-muted-foreground text-center leading-relaxed mb-6">This <strong class="font-bold text-foreground">1-minute quiz</strong> looks at your symptoms and risk factors to build your <strong class="font-bold text-foreground">personalized remineralization plan</strong>.</p>' +
      testimonialHtml(
        ASSETS.testimonialJessica,
        "JESSICA M.",
        'I did everything right and my teeth kept getting worse. Luckily <strong class="not-italic text-foreground">LarineCo™ gave me a healthier, more confident smile.</strong> Very happy I took this quiz.'
      ) +
      '<div class="mt-6">' +
      renderTeethSelector(true) +
      "</div></div>";

    bindTeeth(stage, true);
  }

  function testimonialHtml(image, name, quoteHtml) {
    return (
      '<div class="bg-primary-tint border border-primary/15 rounded-2xl p-5 mb-7">' +
      '<div class="flex items-start gap-4">' +
      '<img src="' +
      image +
      '" alt="' +
      escapeHtml(name) +
      '" loading="lazy" width="80" height="80" class="w-20 h-20 rounded-full object-cover object-top flex-shrink-0 border-2 border-card shadow-card" />' +
      '<div>' +
      '<p class="text-[13.5px] text-muted-foreground italic leading-relaxed mb-2">"' +
      quoteHtml +
      '"</p>' +
      '<div class="flex items-center gap-2">' +
      '<div class="text-[11px] font-bold tracking-wider text-foreground">' +
      escapeHtml(name) +
      "</div>" +
      '<span class="text-[10px] text-success">★★★★★</span>' +
      "</div>" +
      '<div class="text-[10px] uppercase tracking-wider text-primary mt-0.5">Verified Customer</div>' +
      "</div></div></div>"
    );
  }

  function optHtml(icon, label, selected, dataAttr, dataVal) {
    var attr = dataAttr ? ' data-' + dataAttr + '="' + escapeHtml(dataVal) + '"' : "";
    return (
      '<button type="button"' +
      attr +
      ' class="' +
      cn(
        "w-full px-4 py-3.5 bg-card border-[1.5px] rounded-xl text-left text-sm font-medium transition-all flex items-center gap-3",
        selected
          ? "border-primary bg-primary-soft text-primary-deep"
          : "border-border text-foreground hover:border-primary hover:bg-primary-tint"
      ) +
      '">' +
      (icon ? '<span class="text-lg w-6 text-center flex-shrink-0">' + icon + "</span>" : "") +
      '<span class="flex-1"><span class="block">' +
      escapeHtml(label) +
      "</span></span></button>"
    );
  }

  function renderQConcern() {
    stage.innerHTML =
      '<div class="animate-fade-up">' +
      progressHtml(2, TOTAL_Q) +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">What\'s <span class="text-primary">your biggest concern</span> about your teeth right now?</h2>' +
      '<div class="flex flex-col gap-2.5 mt-3">' +
      CONCERN_OPTS.map(function (pair) {
        return optHtml(pair[0], pair[1], state.answers.concern === pair[1], "concern", pair[1]);
      }).join("") +
      "</div></div>";

    stage.querySelectorAll("[data-concern]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var label = btn.getAttribute("data-concern");
        setAns("concern", label);
        setTimeout(function () {
          go("q-warnings");
        }, 280);
      });
    });
  }

  function toggleArray(arr, v) {
    var copy = arr.slice();
    var i = copy.indexOf(v);
    if (i >= 0) copy.splice(i, 1);
    else copy.push(v);
    return copy;
  }

  function renderQWarnings() {
    var sel = state.answers.warnings || [];
    stage.innerHTML =
      "<div>" +
      progressHtml(3, TOTAL_Q) +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">Which of these have you noticed?</h2>' +
      '<div class="flex flex-col gap-2 mt-2">' +
      WARN.map(function (w) {
        var on = sel.indexOf(w) >= 0;
        return (
          '<button type="button" data-warning="' +
          escapeHtml(w) +
          '" class="' +
          cn(
            "flex items-center gap-3 px-4 py-3 bg-card border-[1.5px] rounded-xl text-left transition-all",
            on ? "border-primary bg-primary-soft" : "border-border hover:border-primary hover:bg-primary-tint"
          ) +
          '">' +
          '<span class="' +
          cn(
            "w-5 h-5 rounded border-[1.5px] flex items-center justify-center text-xs flex-shrink-0",
            on ? "bg-primary border-primary text-primary-foreground" : "border-muted-foreground/40"
          ) +
          '">' +
          (on ? "✓" : "") +
          "</span>" +
          '<span class="' +
          cn("text-[13px] font-medium", on ? "text-primary-deep" : "text-foreground") +
          '">' +
          escapeHtml(w) +
          "</span></button>"
        );
      }).join("") +
      "</div>" +
      nextBtnHtml("warnings-next", "Continue", true) +
      "</div>";

    stage.querySelectorAll("[data-warning]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var w = btn.getAttribute("data-warning");
        var next = toggleArray(state.answers.warnings || [], w);
        setAns("warnings", next);
        renderQWarnings();
      });
    });
    var nx = document.getElementById("warnings-next");
    if (nx)
      nx.addEventListener("click", function () {
        go("q-hopes");
      });
  }

  function nextBtnHtml(id, text, show) {
    if (!show) return "";
    return (
      '<button type="button" id="' +
      id +
      '" class="w-full mt-4 py-3.5 bg-gradient-primary text-primary-foreground rounded-xl text-[15px] font-bold tracking-wide shadow-card hover:opacity-90 transition-opacity">' +
      escapeHtml(text) +
      "</button>"
    );
  }

  function renderQHopes() {
    var sel = state.answers.hopes || [];
    stage.innerHTML =
      "<div>" +
      progressHtml(4, TOTAL_Q) +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">What results are you hoping for from an oral care product?</h2>' +
      '<div class="flex flex-col gap-2 mt-2">' +
      HOPES.map(function (g) {
        var on = sel.indexOf(g) >= 0;
        return (
          '<button type="button" data-hope="' +
          escapeHtml(g) +
          '" class="' +
          cn(
            "flex items-center gap-3 px-4 py-3 bg-card border-[1.5px] rounded-xl text-left transition-all",
            on ? "border-primary bg-primary-soft" : "border-border hover:border-primary hover:bg-primary-tint"
          ) +
          '">' +
          '<span class="' +
          cn(
            "w-5 h-5 rounded border-[1.5px] flex items-center justify-center text-xs flex-shrink-0",
            on ? "bg-primary border-primary text-primary-foreground" : "border-muted-foreground/40"
          ) +
          '">' +
          (on ? "✓" : "") +
          "</span>" +
          '<span class="' +
          cn("text-[13px] font-medium", on ? "text-primary-deep" : "text-foreground") +
          '">' +
          escapeHtml(g) +
          "</span></button>"
        );
      }).join("") +
      "</div>" +
      nextBtnHtml("hopes-next", "Continue", sel.length > 0) +
      "</div>";

    stage.querySelectorAll("[data-hope]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var g = btn.getAttribute("data-hope");
        setAns("hopes", toggleArray(state.answers.hopes || [], g));
        renderQHopes();
      });
    });
    var hn = document.getElementById("hopes-next");
    if (hn)
      hn.addEventListener("click", function () {
        go("q-sensitivity");
      });
  }

  function renderSimpleQ(opts) {
    var qNum = opts.qNum,
      next = opts.next,
      question = opts.question,
      pairs = opts.pairs,
      ansKey = opts.ansKey;
    var items = pairs
      .map(function (pair) {
        return optHtml(pair[0], pair[1], state.answers[ansKey] === pair[1], "simple-opt", pair[1]);
      })
      .join("");

    stage.innerHTML =
      '<div class="animate-fade-up">' +
      progressHtml(qNum, TOTAL_Q) +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">' +
      question +
      "</h2>" +
      '<div class="flex flex-col gap-2.5 mt-4">' +
      items +
      "</div></div>";

    stage.querySelectorAll("[data-simple-opt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var label = btn.getAttribute("data-simple-opt");
        setAns(ansKey, label);
        setTimeout(function () {
          go(next);
        }, 280);
      });
    });
  }

  function circleStatHtml(id, percent, label, sublabel) {
    var r = 42,
      c = 2 * Math.PI * r;
    return (
      '<div class="flex flex-col items-center">' +
      '<div class="relative w-28 h-28">' +
      '<svg viewBox="0 0 100 100" class="w-full h-full -rotate-90">' +
      '<circle cx="50" cy="50" r="' +
      r +
      '" fill="none" stroke="hsl(var(--border))" stroke-width="9" />' +
      '<circle data-circle-stat="' +
      id +
      '" cx="50" cy="50" r="' +
      r +
      '" fill="none" stroke="hsl(var(--primary))" stroke-width="9" stroke-linecap="round" stroke-dasharray="' +
      c +
      '" stroke-dashoffset="' +
      c +
      '" />' +
      "</svg>" +
      '<div class="absolute inset-0 flex items-center justify-center">' +
      '<span data-circle-label="' +
      id +
      '" class="text-2xl font-extrabold text-primary leading-none whitespace-nowrap">' +
      (sublabel != null ? escapeHtml(sublabel) : "0%") +
      "</span>" +
      "</div></div>" +
      '<div class="text-[12px] font-semibold text-foreground text-center mt-2 leading-tight max-w-[140px]">' +
      escapeHtml(label) +
      "</div></div>"
    );
  }

  function animateCircleStats(root, specs) {
    specs.forEach(function (spec) {
      var circle = root.querySelector('[data-circle-stat="' + spec.id + '"]');
      var labelEl = root.querySelector('[data-circle-label="' + spec.id + '"]');
      if (!circle || !labelEl) return;
      var r = 42,
        c = 2 * Math.PI * r;
      var percent = spec.percent;
      var duration = 1500;
      var start = performance.now();

      function tick(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        var animated = eased * percent;
        var offset = c - (animated / 100) * c;
        circle.setAttribute("stroke-dashoffset", String(offset));
        labelEl.textContent = spec.sublabel != null ? spec.sublabel : Math.round(animated) + "%";
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  function renderEduNotAlone() {
    stage.innerHTML =
      '<div class="animate-fade-up">' +
      progressHtml(6, TOTAL_Q) +
      '<div class="text-center mb-5">' +
      '<p class="text-[20px] sm:text-[22px] font-bold text-foreground max-w-sm mx-auto leading-snug">You\'re Not Alone.</p>' +
      "</div>" +
      '<div class="bg-card rounded-2xl border border-border p-5 mb-4 shadow-card">' +
      '<div class="grid grid-cols-3 gap-3 items-start">' +
      circleStatHtml("c1", 42, "of adults have sensitive teeth", null) +
      circleStatHtml("c2", 64.8, "are most sensitive to cold beverages", "64.8%") +
      circleStatHtml("c3", 26, "of adults have an untreated cavity", null) +
      "</div>" +
      '<div class="bg-primary-soft rounded-lg px-4 py-3 mt-5 text-[13px] text-primary-deep font-medium leading-relaxed text-center">🦷 The good news. Natural oral care is the best form of prevention.</div>' +
      '<p class="text-[11px] text-muted-foreground text-center mt-2">*Based on peer-reviewed studies</p>' +
      "</div>" +
      bigCta("Continue", "edu-notalone-next") +
      "</div>";

    animateCircleStats(stage, [
      { id: "c1", percent: 42 },
      { id: "c2", percent: 64.8, sublabel: "64.8%" },
      { id: "c3", percent: 26 },
    ]);

    stage.querySelector('[data-action="edu-notalone-next"]').addEventListener("click", function () {
      go("q-acidic");
    });
  }

  function renderEduStat() {
    stage.innerHTML =
      '<div class="animate-fade-up">' +
      progressHtml(8, TOTAL_Q) +
      '<div class="bg-card rounded-2xl border border-border p-5 mb-4 shadow-card animate-fade-up">' +
      '<h3 class="text-[17px] font-bold text-foreground mb-2 leading-snug">Daily acidic drinks are a hidden cause of enamel loss</h3>' +
      '<div class="text-[13.5px] text-muted-foreground leading-relaxed space-y-2">' +
      "<p>Sipping sugary drinks throughout the day keeps the mouth in a <strong class=\"font-bold underline text-foreground\">constant acidic state</strong>, preventing saliva from repairing teeth.</p>" +
      '<figure class="mt-3">' +
      '<img src="' +
      ASSETS.phChart +
      '" alt="Acidity (pH) chart of common drinks and how they affect tooth enamel" loading="lazy" class="w-full rounded-xl border border-border" />' +
      '<figcaption class="text-[11px] text-muted-foreground text-center mt-2 italic">Anything below pH 5.5 begins to demineralize and erode enamel</figcaption>' +
      "</figure></div></div>" +
      bigCta("Continue", "edu-stat-next") +
      "</div>";

    stage.querySelector('[data-action="edu-stat-next"]').addEventListener("click", function () {
      go("q-stain");
    });
  }

  function renderQStain() {
    var sel = state.answers.stains || [];
    stage.innerHTML =
      "<div>" +
      progressHtml(9, TOTAL_Q) +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">What do you think is causing the staining?</h2>' +
      '<div class="grid grid-cols-2 gap-2.5">' +
      STAIN_OPTS.map(function (pair) {
        var label = pair[1],
          icon = pair[0];
        var on = sel.indexOf(label) >= 0;
        return (
          '<button type="button" data-stain="' +
          escapeHtml(label) +
          '" class="' +
          cn(
            "border-[1.5px] rounded-xl p-3 text-center transition-all bg-card",
            on ? "border-primary bg-primary-soft" : "border-border hover:border-primary hover:bg-primary-tint"
          ) +
          '">' +
          '<span class="text-2xl block mb-1">' +
          icon +
          "</span>" +
          '<span class="text-[12px] font-semibold text-foreground">' +
          escapeHtml(label) +
          "</span></button>"
        );
      }).join("") +
      "</div>" +
      nextBtnHtml("stain-next", "Continue", true) +
      "</div>";

    stage.querySelectorAll("[data-stain]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var label = btn.getAttribute("data-stain");
        setAns("stains", toggleArray(state.answers.stains || [], label));
        renderQStain();
      });
    });
    document.getElementById("stain-next").addEventListener("click", function () {
      go("edu-stains");
    });
  }

  function renderEduStains() {
    stage.innerHTML =
      '<div class="animate-fade-up">' +
      progressHtml(10, TOTAL_Q) +
      '<div class="bg-card rounded-2xl border border-border p-5 mb-4 shadow-card animate-fade-up">' +
      '<h3 class="text-[17px] font-bold text-foreground mb-2 leading-snug"><mark class="bg-primary-soft text-primary-deep px-1 rounded">Staining is the leading reason</mark> adults feel self-conscious about their smile</h3>' +
      '<figure class="my-3">' +
      '<img src="' +
      ASSETS.stainTypes +
      '" alt="Common types of tooth stains" loading="lazy" class="w-full rounded-xl border border-border" />' +
      "</figure>" +
      '<div class="text-[13.5px] text-muted-foreground leading-relaxed space-y-2">' +
      "<p>Acid buildup thins enamel over time, making the <strong class=\"font-bold underline text-foreground\">yellow layer underneath more visible</strong>.</p>" +
      "</div></div>" +
      '<button type="button" data-action="edu-stains-next" class="w-full py-4 bg-gradient-primary text-primary-foreground rounded-xl text-base font-bold shadow-card hover:opacity-90 transition">Continue</button>' +
      "</div>";

    stage.querySelector('[data-action="edu-stains-next"]').addEventListener("click", function () {
      go("q-brush");
    });
  }

  function renderQBrush() {
    renderSimpleQ({
      qNum: 12,
      next: "q-age",
      question: "How often do you brush your teeth?",
      pairs: [
        ["", "3+ times a day"],
        ["", "Twice a day"],
        ["", "Once a day"],
        ["", "Inconsistently"],
      ],
      ansKey: "brush",
    });
  }

  function renderQAge() {
    var ages = ["50+ years old", "40 – 49 years old", "30 – 39 years old", "20 – 29 years old", "Under 20"];
    var agePart =
      '<div class="flex flex-col gap-2.5 mt-3">' +
      ages
        .map(function (label) {
          return optHtml("", label, state.answers.age === label, "age-opt", label);
        })
        .join("") +
      "</div>";

    var genderPart = "";
    if (state.answers.age) {
      genderPart =
        '<div class="mt-5">' +
        '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">What\'s your gender?</h2>' +
        '<div class="grid grid-cols-2 gap-2.5 mt-3">' +
        optHtml("♀️", "Female", state.answers.gender === "Female", "gender-opt", "Female") +
        optHtml("♂️", "Male", state.answers.gender === "Male", "gender-opt", "Male") +
        "</div></div>";
    }

    stage.innerHTML =
      "<div>" +
      progressHtml(13, TOTAL_Q) +
      '<h2 class="text-[19px] leading-[1.3] font-bold text-center text-foreground mb-1.5">How old are you?</h2>' +
      agePart +
      genderPart +
      nextBtnHtml("age-next", "Continue", !!(state.answers.age && state.answers.gender)) +
      "</div>";

    stage.querySelectorAll("[data-age-opt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var nextAge = btn.getAttribute("data-age-opt");
        if (nextAge === state.answers.age) return;
        setAns("age", nextAge);
        renderQAge();
      });
    });
    stage.querySelectorAll("[data-gender-opt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var nextGender = btn.getAttribute("data-gender-opt");
        if (nextGender === state.answers.gender) return;
        setAns("gender", nextGender);
        renderQAge();
      });
    });
    var an = document.getElementById("age-next");
    if (an)
      an.addEventListener("click", function () {
        go("commit");
      });
  }

  function renderCommit() {
    stage.innerHTML =
      '<div class="text-center py-6 animate-fade-up">' +
      '<div class="text-5xl mb-4">🦷</div>' +
      '<h2 class="text-2xl font-bold text-foreground mb-3">You\'re in the right place.</h2>' +
      '<p class="text-sm text-muted-foreground leading-relaxed mb-6 max-w-md mx-auto">Based on your answers, your enamel is showing multiple signs of active mineral loss. We\'re putting your personalized plan together now.</p>' +
      bigCta("See My Results", "commit-next") +
      "</div>";

    stage.querySelector('[data-action="commit-next"]').addEventListener("click", function () {
      go("analyzing");
    });
  }

  function renderAnalyzing() {
    var steps = [
      "Assessing sensitivity and stain levels…",
      "Calculating enamel erosion risk…",
      "Mapping your remineralization needs…",
      "Identifying your key risk drivers…",
      "Building your personalized plan…",
    ];

    var rowMarkup = steps
      .map(function (s, i) {
        return (
          '<div class="flex items-center gap-3 text-[13px] transition-colors text-muted-foreground/60" data-analyze-row="' +
          i +
          '">' +
          '<span class="analyzing-dot w-2.5 h-2.5 rounded-full flex-shrink-0 bg-border"></span>' +
          escapeHtml(s) +
          "</div>"
        );
      })
      .join("");

    stage.innerHTML =
      '<div class="text-center py-10">' +
      '<h2 class="text-xl font-bold text-foreground mb-7">Analyzing your enamel profile…</h2>' +
      '<div class="w-20 h-20 rounded-full border-[3px] border-primary mx-auto mb-7 flex items-center justify-center bg-primary-tint">' +
      '<svg viewBox="0 0 32 32" fill="none" class="w-10 h-10">' +
      '<path d="M7 16l7 7L25 9" stroke="hsl(var(--primary))" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />' +
      "</svg></div>" +
      '<div class="flex flex-col gap-3 max-w-xs mx-auto text-left">' +
      rowMarkup +
      "</div></div>";

    var rowEls = stage.querySelectorAll("[data-analyze-row]");
    var stepIdx = 0;

    function paintRows() {
      rowEls.forEach(function (row, i) {
        var dot = row.querySelector(".analyzing-dot");
        row.className = cn(
          "flex items-center gap-3 text-[13px] transition-colors",
          i < stepIdx ? "text-foreground" : i === stepIdx ? "text-foreground" : "text-muted-foreground/60"
        );
        dot.className = cn(
          "analyzing-dot w-2.5 h-2.5 rounded-full flex-shrink-0",
          i < stepIdx ? "bg-success" : i === stepIdx ? "bg-primary animate-pulse" : "bg-border"
        );
      });
    }

    function loop() {
      paintRows();
      if (stepIdx >= steps.length) {
        setTimeout(function () {
          go("result");
        }, 600);
        return;
      }
      setTimeout(function () {
        stepIdx += 1;
        loop();
      }, 800);
    }

    loop();
  }

  function pickProfile(gender, age) {
    var isMale = gender === "Male";
    var m = {
      teen: ASSETS.profileMaleTeen,
      "20": ASSETS.profileMale20,
      "30": ASSETS.profileMale30,
      "40": ASSETS.profileMale40,
      "50": ASSETS.profileMale50,
    };
    var f = {
      teen: ASSETS.profileFemaleTeen,
      "20": ASSETS.profileFemale20,
      "30": ASSETS.profileFemale30,
      "40": ASSETS.profileFemale40,
      "50": ASSETS.profileFemale50,
    };
    var set = isMale ? m : f;
    if (age && age.indexOf("Under") === 0) return set.teen;
    if (age && age.indexOf("20") === 0) return set["20"];
    if (age && age.indexOf("30") === 0) return set["30"];
    if (age && age.indexOf("40") === 0) return set["40"];
    return set["50"];
  }

  function renderResult() {
    var profileSrc = pickProfile(state.answers.gender, state.answers.age);
    var stats = [
      ["⚡", "Decline pattern", "Progressive"],
      ["📈", "Room for improvement", "High"],
      ["🔥", "Root causes", "Diet + Routine"],
      ["🦷", "Quality of life impact", "Substantial"],
    ];

    stage.innerHTML =
      '<div class="animate-fade-up">' +
      '<h1 class="text-[26px] leading-[1.25] font-bold text-center text-foreground mb-2.5 !text-[22px] mb-3">Summary of your profile</h1>' +
      '<div class="bg-card rounded-2xl border border-border p-4 mb-3 shadow-card relative overflow-hidden">' +
      '<div class="flex items-start justify-between mb-1">' +
      '<div class="text-[13px] font-bold text-foreground">Level of Enamel Risk</div>' +
      '<div class="text-[10px] font-extrabold text-primary-deep border-2 border-primary rounded-md px-2 py-1 tracking-widest">HIGH LEVEL</div>' +
      "</div>" +
      '<div class="relative h-44 -mx-1 mb-3 flex items-end justify-center bg-white rounded-xl overflow-hidden">' +
      '<img src="' +
      profileSrc +
      '" alt="Your profile" loading="lazy" width="768" height="768" class="h-full w-auto object-contain object-bottom" />' +
      "</div>" +
      '<div class="relative px-1">' +
      '<div class="relative h-3 rounded-full" style="background:linear-gradient(to right, hsl(var(--success)), hsl(var(--warning)) 55%, hsl(var(--danger)))">' +
      '<div class="absolute -top-9 flex flex-col items-center" style="left:75%;transform:translateX(-50%)">' +
      '<div class="bg-foreground text-background text-[9px] font-bold px-2 py-1 rounded-md tracking-widest whitespace-nowrap">YOUR LEVEL</div>' +
      '<div class="w-0 h-0 border-l-[5px] border-r-[5px] border-t-[5px] border-l-transparent border-r-transparent border-t-foreground"></div>' +
      "</div>" +
      '<div class="absolute -top-1 w-5 h-5 rounded-full bg-card border-[3px] border-primary shadow-elevated" style="left:75%;transform:translateX(-50%)"></div>' +
      "</div>" +
      '<div class="flex justify-between text-[9px] uppercase tracking-wider text-muted-foreground mt-2 font-bold">' +
      "<span>Low</span><span>Normal</span><span>Medium</span><span>High</span>" +
      "</div></div>" +
      '<div class="bg-primary-tint border border-primary/20 rounded-lg p-3 mt-4 flex gap-2.5">' +
      '<span class="text-base">⚠️</span>' +
      '<div><strong class="text-[12px] text-primary-deep block mb-0.5">Enamel Assessment: DECLINING</strong>' +
      '<p class="text-[11px] text-muted-foreground leading-relaxed">Your enamel is significantly below peak. This results from accumulated acid exposure, mineral loss, and daily habits.</p></div></div>' +
      '<div class="grid grid-cols-2 gap-2 mt-3">' +
      stats
        .map(function (t) {
          return (
            '<div class="bg-muted/60 rounded-lg p-2.5 flex items-start gap-2">' +
            '<span class="text-sm">' +
            t[0] +
            "</span><div>" +
            '<div class="text-[9px] uppercase tracking-wider text-muted-foreground mb-0.5 font-bold">' +
            escapeHtml(t[1]) +
            "</div>" +
            '<div class="text-[12px] font-bold text-foreground leading-tight">' +
            escapeHtml(t[2]) +
            "</div></div></div>"
          );
        })
        .join("") +
      "</div></div>" +
      '<div class="bg-card rounded-2xl border border-border p-5 mb-3 shadow-card">' +
      '<div class="text-sm font-bold text-foreground mb-3">Key findings from your answers</div>' +
      "<ul class=\"flex flex-col gap-2.5\">" +
      [
        "Regular acid exposure may be wearing down enamel",
        "Sensitivity level indicates active enamel thinning is underway",
        "Staining pattern suggests both surface and structural discoloration",
        "Current routine is hardening rather than rebuilding enamel",
        "Oral microbiome imbalance likely contributing to bad breath and erosion",
      ]
        .map(function (f) {
          return (
            '<li class="flex items-start gap-2.5 text-[13px] text-muted-foreground leading-relaxed">' +
            '<span class="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-2"></span>' +
            escapeHtml(f) +
            "</li>"
          );
        })
        .join("") +
      "</ul></div>" +
      bigCta("See my personalized solution", "result-next") +
      "</div>";

    stage.querySelector('[data-action="result-next"]').addEventListener("click", function () {
      go("timeline");
    });
  }

  function renderTimeline() {
    var benefits = [
      { icon: "🌬️", title: "Fresher breath", note: "" },
      { icon: "🦷", title: "Stronger-feeling teeth", note: "" },
      { icon: "✨", title: "Brighter natural shade", note: "" },
      { icon: "🛡️", title: "Daily enamel protection", note: "" },
      { icon: "🍃", title: "More comfortable gums", note: "" },
      { icon: "😁", title: "More smile confidence", note: "" },
    ];

    stage.innerHTML =
      '<div class="animate-fade-up">' +
      '<h1 class="text-[26px] leading-[1.25] font-bold text-center text-foreground mb-2.5 !text-[22px] mb-2">Your personalized solution</h1>' +
      '<p class="text-sm text-muted-foreground text-center leading-relaxed mb-6">Based on your answers, here\'s what consistent daily use of LarineCo™ can support:</p>' +
      '<div class="bg-card rounded-2xl border border-border p-4 my-4 shadow-card">' +
      '<div class="grid grid-cols-2 gap-2.5">' +
      benefits
        .map(function (b, i) {
          return (
            '<div class="rounded-xl border border-border bg-background/50 p-3 animate-fade-up" style="animation-delay:' +
            i * 80 +
            'ms">' +
            '<div class="text-2xl leading-none mb-1.5">' +
            b.icon +
            "</div>" +
            '<div class="text-[12.5px] font-bold text-foreground leading-tight">' +
            escapeHtml(b.title) +
            "</div>" +
            '<div class="text-[11px] text-muted-foreground leading-snug mt-0.5">' +
            escapeHtml(b.note) +
            "</div></div>"
          );
        })
        .join("") +
      "</div></div>" +
      testimonialHtml(
        ASSETS.testimonialMark,
        "MARK T.",
        "The sensitivity when drinking cold water was basically gone. I hadn't realized how much I'd been avoiding things until I stopped having to."
      ) +
      bigCta("See how it works", "timeline-next") +
      "</div>";

    stage.querySelector('[data-action="timeline-next"]').addEventListener("click", function () {
      go("applying");
    });
  }

  function renderApplying() {
    stage.innerHTML =
      '<div class="flex flex-col items-center justify-center text-center py-16">' +
      '<div class="relative w-44 h-44 mb-10">' +
      '<span class="absolute inset-0 rounded-full border border-primary/30 animate-ping-slow"></span>' +
      '<span class="absolute inset-2 rounded-full border border-primary/20 animate-ping-slower"></span>' +
      '<svg id="apply-ring-spin" viewBox="0 0 120 120" class="absolute inset-0 h-full w-full transition-opacity duration-500 opacity-100 animate-spin-slow">' +
      '<defs><linearGradient id="apply-ring-grad" x1="0%" y1="0%" x2="100%" y2="100%">' +
      '<stop offset="0%" stop-color="hsl(var(--primary))" stop-opacity="0" />' +
      '<stop offset="100%" stop-color="hsl(var(--primary))" />' +
      "</linearGradient></defs>" +
      '<circle cx="60" cy="60" r="54" fill="none" stroke="hsl(var(--border))" stroke-width="2" />' +
      '<circle cx="60" cy="60" r="54" fill="none" stroke="url(#apply-ring-grad)" stroke-width="3" stroke-linecap="round" stroke-dasharray="200 340" />' +
      "</svg>" +
      '<svg id="apply-ring-check" viewBox="0 0 120 120" class="absolute inset-0 h-full w-full scale-90 opacity-0 transition-all duration-500">' +
      '<circle cx="60" cy="60" r="54" fill="none" stroke="hsl(var(--primary))" stroke-width="3" />' +
      '<path id="apply-check-path" d="M40 62 L54 76 L82 46" fill="none" stroke="hsl(var(--primary))" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="80" stroke-dashoffset="80" style="transition: stroke-dashoffset 0.6s ease-out 0.1s" />' +
      "</svg>" +
      '<span id="apply-glow" class="absolute inset-6 rounded-full bg-primary/20 blur-2xl opacity-30 transition-opacity duration-700"></span>' +
      "</div>" +
      '<div id="apply-sub" class="mb-3 text-[11px] font-bold uppercase tracking-[0.3em] text-primary"></div>' +
      '<h2 id="apply-title" class="mb-2 text-2xl font-bold text-foreground"></h2>' +
      '<p id="apply-desc" class="max-w-xs text-sm text-muted-foreground"></p>' +
      '<div class="mt-8 flex items-center gap-2">' +
      '<span id="apply-dot-0" class="h-1.5 w-1.5 rounded-full bg-primary transition-colors"></span>' +
      '<span id="apply-dot-1" class="h-1.5 w-1.5 rounded-full bg-border transition-colors"></span>' +
      '<span id="apply-dot-2" class="h-1.5 w-1.5 rounded-full bg-border transition-colors"></span>' +
      "</div></div>";

    var ringSpin = stage.querySelector("#apply-ring-spin");
    var ringCheck = stage.querySelector("#apply-ring-check");
    var checkPath = stage.querySelector("#apply-check-path");
    var glow = stage.querySelector("#apply-glow");
    var subEl = stage.querySelector("#apply-sub");
    var titleEl = stage.querySelector("#apply-title");
    var descEl = stage.querySelector("#apply-desc");
    var dots = [
      stage.querySelector("#apply-dot-0"),
      stage.querySelector("#apply-dot-1"),
      stage.querySelector("#apply-dot-2"),
    ];

    function paintApplying(idx) {
      subEl.textContent = idx < 2 ? "Almost there" : "Success";
      titleEl.textContent =
        idx === 0 ? "Applying your discount…" : idx === 1 ? "Locking in your savings…" : "Discount applied!";
      descEl.textContent =
        idx < 2
          ? "Hold tight — we're personalizing your offer based on your enamel profile."
          : "Redirecting you to your personalized plan…";

      ringSpin.classList.toggle("opacity-0", idx >= 1);
      ringSpin.classList.toggle("opacity-100", idx < 1);
      ringSpin.classList.toggle("animate-spin-slow", idx < 1);

      ringCheck.classList.toggle("opacity-0", idx < 1);
      ringCheck.classList.toggle("opacity-100", idx >= 1);
      ringCheck.classList.toggle("scale-90", idx < 1);
      ringCheck.classList.toggle("scale-100", idx >= 1);

      checkPath.setAttribute("stroke-dashoffset", idx >= 1 ? "0" : "80");

      glow.classList.toggle("opacity-30", idx < 1);
      glow.classList.toggle("opacity-100", idx >= 1);

      dots.forEach(function (dot, i) {
        dot.classList.toggle("bg-primary", idx >= i);
        dot.classList.toggle("bg-border", idx < i);
      });
    }

    paintApplying(0);

    setTimeout(function () {
      paintApplying(1);
    }, 1600);
    setTimeout(function () {
      paintApplying(2);
    }, 2400);
    setTimeout(function () {
      go("product");
    }, 3400);
  }

  function renderProduct() {
    var bullets = [
      ["🦷", "Supports strong teeth and enamel at the mineral level"],
      ["✨", "Brightens your smile by restoring enamel surface"],
      ["🌬️", "Long-lasting fresh breath all day"],
      ["🛡️", "Fights odor-causing bacteria naturally"],
      ["💚", "Supports healthy gums & a balanced oral microbiome"],
      ["🌿", "Fluoride-free, sugar-free — safe for daily use"],
    ];

    stage.innerHTML =
      '<div class="animate-fade-up">' +
      '<h1 class="text-[26px] leading-[1.25] font-bold text-center text-foreground mb-2.5 !text-[22px] mb-2">Your personalized solution is ready</h1>' +
      '<p class="text-sm text-muted-foreground text-center leading-relaxed mb-6">Because you qualify, we recommend starting with a 30-day supply — backed by our 30-day money-back guarantee.</p>' +
      '<figure class="mb-4 rounded-2xl overflow-hidden shadow-elevated border border-border">' +
      '<img src="' +
      ASSETS.heroImg +
      '" alt="LarineCo Remineralizing Gum — Strong Teeth, Brighter Smile, Fresh Breath, Fights Bacteria" loading="lazy" class="w-full h-auto block" />' +
      "</figure>" +
      '<div class="bg-card rounded-2xl border border-border p-5 mb-3 shadow-card">' +
      '<div class="text-[18px] font-bold text-foreground mb-1 text-center">LarineCo™ Remineralizing Gum</div>' +
      '<div class="text-[12px] text-muted-foreground mb-4 leading-relaxed text-center">Nano-Hydroxyapatite · Xylitol · Mastic · Myrrh · Spruce · Acacia</div>' +
      '<ul class="flex flex-col gap-2.5 text-left mb-2">' +
      bullets
        .map(function (row) {
          return (
            '<li class="text-[13px] text-foreground flex items-start gap-2.5 leading-relaxed">' +
            '<span class="text-base flex-shrink-0 w-5 text-center">' +
            row[0] +
            "</span>" +
            escapeHtml(row[1]) +
            "</li>"
          );
        })
        .join("") +
      "</ul></div>" +
      '<div class="bg-card rounded-2xl border border-border p-5 mb-3 shadow-elevated text-center">' +
      '<div class="inline-flex items-center gap-2 bg-primary-soft border border-primary/20 rounded-full px-4 py-1.5 mb-3">' +
      '<span class="text-[11px] font-bold text-primary-deep uppercase tracking-widest">Your Discount</span>' +
      '<span class="text-[12px] bg-primary text-primary-foreground px-2.5 py-0.5 rounded-full font-bold">50% OFF</span>' +
      "</div>" +
      '<div class="text-[13px] text-muted-foreground mb-4 leading-relaxed">30-day supply · Free shipping · Applied at checkout</div>' +
      '<a href="https://buylarine.com/products/larineco%E2%84%A2%EF%B8%8F-remineralizing-gum-copy" class="w-full block py-4 bg-gradient-primary text-primary-foreground rounded-xl text-base font-bold shadow-card hover:opacity-90 transition tracking-wide">Claim My 50% Off</a>' +
      '<div class="text-[11px] text-muted-foreground mt-3">Try risk-free for 30 days</div>' +
      "</div></div>";
  }

  function render() {
    switch (state.screen) {
      case "intro":
        renderIntro();
        break;
      case "q-teeth":
        stage.innerHTML = '<div class="animate-fade-up">' + renderTeethSelector(false) + "</div>";
        bindTeeth(stage, false);
        scrollTop();
        break;
      case "q-concern":
        renderQConcern();
        break;
      case "q-stain":
        renderQStain();
        break;
      case "edu-stains":
        renderEduStains();
        break;
      case "q-hopes":
        renderQHopes();
        break;
      case "q-sensitivity":
        renderSimpleQ({
          qNum: 5,
          next: "edu-notalone",
          question:
            "How sensitive are your teeth to hot, cold, or sweet things?",
          pairs: [
            ["🔥", "Constant — even normal food and drinks hurt"],
            ["❄️", "Noticeable with hot, cold, or sweet things"],
            ["😐", "Mild — comes and goes"],
            ["✅", "Not sensitive — just want to protect my teeth"],
          ],
          ansKey: "sensitivity",
        });
        break;
      case "edu-notalone":
        renderEduNotAlone();
        break;
      case "q-warnings":
        renderQWarnings();
        break;
      case "q-acidic":
        renderSimpleQ({
          qNum: 7,
          next: "edu-stat",
          question:
            "How often do you drink coffee, tea, soda, or citrus drinks?",
          pairs: [
            ["☕", "Multiple times a day"],
            ["🥤", "Once a day"],
            ["📅", "A few times a week"],
            ["💧", "Rarely or never"],
          ],
          ansKey: "acidic",
        });
        break;
      case "edu-stat":
        renderEduStat();
        break;
      case "q-brush":
        renderQBrush();
        break;
      case "q-age":
        renderQAge();
        break;
      case "commit":
        renderCommit();
        break;
      case "analyzing":
        renderAnalyzing();
        break;
      case "result":
        renderResult();
        break;
      case "timeline":
        renderTimeline();
        break;
      case "applying":
        renderApplying();
        break;
      case "product":
        renderProduct();
        break;
      default:
        stage.innerHTML =
          '<p class="text-center text-muted-foreground">Unknown screen.</p>';
    }
  }

  render();
})();
